import { render, staticRenderFns } from "./inspections.vue?vue&type=template&id=17231526&"
import script from "./inspections.vue?vue&type=script&lang=js&"
export * from "./inspections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports